export default __webpack_public_path__ + "static/clock-2566c916b2ded8882b1b17803ce21a28.gif";